import * as yaml from "js-yaml";
import { customTags } from "./customTags.js";
import getLogger from "./utils/logger.js";
const logger = getLogger("parser:parser");
const parse = (yamlData, schemas = []) => {
  const SCHEMA = yaml.DEFAULT_SCHEMA.extend(schemas);
  try {
    const loaded = yaml.load(yamlData, { schema: SCHEMA });
    return loaded;
  } catch (error) {
    logger.error("Error parsing YAML:", error.message);
    return null;
  }
};
const parseAll = (yamlData) => parse(yamlData, Object.values(customTags));
export {
  customTags,
  parse,
  parseAll,
  parseAll as parseYaml
};
